export const requesterrorType = { type: 'REQUEST_ERROR' };
export const requestType = { type: 'REQUEST' };
export const requestStartType = { type: 'REQUEST_START' };
export const showLoader = { type: 'showLoader' };
export const isLoaded = { type: 'isLoaded' };
export const clientConfiguration = { type: 'clientConfiguration' };